import Cookies from 'js-cookie';
import { ExperimentData } from '~helpers/experiments';

export const CONTENTEXP_755 = {
  identifier: 'contentexp-14-auth0-sign-ups',
  control: 'contentexp-14-auth0-sign-ups-control',
  treatment: 'contentexp-14-auth0-sign-ups-treatment',
};

export function setExperimentCookies(experiments?: ExperimentData[]): void {
  experiments?.[0]?.cookies?.forEach(cookie => {
    const { name, value, age } = cookie;
    Cookies.set(name, value, { expires: age });
  });
}
